<template>
    <div class="about">
        <h1>About Page</h1> 
    </div>
</template>
  
<script>
export default {
    name: 'AboutComponent',
}
</script>
  
  